import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { WelcomeMsgToCorporateUserComponent } from './shared/welcome-msg-to-corporate-user/welcome-msg-to-corporate-user.component';
import { WelcomeMsgToNonCorpUserComponent } from './shared/welcome-msg-to-non-corp-user/welcome-msg-to-non-corp-user.component';

export const appRoutes: Routes = [
  { path: 'maintenance', component: MaintenanceComponent },
  { path: 'welcome-to-corp', component: WelcomeMsgToCorporateUserComponent },
  { path: 'welcome-to-portal', component: WelcomeMsgToNonCorpUserComponent },

  { path: '**', component: PageNotFoundComponent },
];
